import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from "../common/Button";
import { Modal } from "semantic-ui-react";

class Confirm extends Component {
    constructor(props) {
        super(props);
        this.confirm = this.confirm.bind(this);
        this.cancel = this.cancel.bind(this);

        this.state = {
            hidden: false
        };
    }

    // componentWillReceiveProps() {
    //     this.setState({ hidden: false });
    // }

    confirm() {
        this.props.callback(true);
        this.setState({ hidden: true });
    }

    cancel() {
        this.props.callback(false);
        this.setState({ hidden: true });
    }

    render() {
        let { message } = this.props;
        let splitMessage = message.split('$');

        const text = splitMessage[0];

        const titleElement = this.props.title ? <h2>{this.props.title}</h2> : <h2>Opgelet: niet bewaarde wijzigingen!</h2>;
        const cancelText = this.props.cancelText ? this.props.cancelText : "Terug";
        const confirmText = this.props.confirmText ? this.props.confirmText : "Ga verder";
        const hideCancel = this.props.hideCancel;
        const children = this.props.children;
        const showOnTop = this.props.showOnTop;

        const scrollYSize = window.parent.scrollY;
        let top = 0;
        const confirmHeight = 220;
        const headerHeight = 314;

        if (!showOnTop) {
            if (window.innerHeight === window.parent.innerHeight) {
                // lokaal
                top = ((window.innerHeight + confirmHeight) / 2);
            }
            else {
                const x = headerHeight - scrollYSize + (confirmHeight / 2);
                top = window.parent.innerHeight / 2 - x;
                top = top > (window.innerHeight - confirmHeight * 2) ? window.innerHeight - confirmHeight * 2 : top;
                top = top < (confirmHeight / 2) ? (confirmHeight / 2) : top;
            }
        }
        else {
            top = 10;
        }

        const style = { bottom: 'auto', top: top };
        return (
            <Modal
                style={style}
                open={!this.state.hidden}>
                <Modal.Content>
                    {titleElement}
                    <div>{text}</div>
                </Modal.Content>
                <Modal.Actions className={"c-form__actions"}>
                    {hideCancel || <Button autoFocus onClick={this.cancel} text={cancelText} />}
                    <Button onClick={this.confirm} text={confirmText} />
                </Modal.Actions>
            </Modal>);
    }
}

Confirm.propTypes = {
    message: PropTypes.string,
    callback: PropTypes.func,
    title: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    hideCancel: PropTypes.bool,
    children: PropTypes.node,
    showOnTop: PropTypes.bool
};

export default Confirm;